import { ErrorView } from "@/components/error-view";
import { useLang } from "@/hooks/use-lang";

import { DataGrid } from "ui/widget/data-grid";

import { useTop20CostEstimationTable } from "../../../hooks/use-top20-cost-estimation-table";
import { Top20TableData } from "../../../services/get-investor-top20-table";

export const Top20CostEstimationTable = ({
  tableData,
}: {
  tableData: Top20TableData;
}) => {
  const { t, lang } = useLang();
  const table = useTop20CostEstimationTable({ data: tableData.details ?? [] });
  return (
    <DataGrid
      table={table}
      aria-label="cost estimation table"
      className="text-sm"
      headClassName="h-8 bg-slate-50 first:[&>th]:bg-slate-50"
      bodyClassName="divide-y divide-gray-200"
      rowClassName="group h-9 hover:bg-slate-50 first:[&>td]:bg-white first:[&>td]:hover:bg-slate-50 first:[&>td]:border-b first:[&>td]:last:border-b-0"
      stickyColumn={true}
      emptyView={<ErrorView errorType="empty">{t.error.noData}</ErrorView>}
      lang={lang}
    />
  );
};
